module.exports = __webpack_public_path__ + "img/v3.0.11184827.png";